export const APPLICATION_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScmwD13_WFtAP8D117MvDGtA1GurN42bpx_vOwU8v8O8P7mSA/viewform';

export const DEADLINE = '2026. 03. 16.  까지';

export const REQUIREMENTS =
  '국립창원대학교 컴퓨터공학과·정보통신공학과 1~2학년 / 사림아너스학부·공학계열 자율전공학부';

export const HOMEPAGE_URL = 'https://www.casper.or.kr';
